import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

interface WindowsAppFeature {
  title: string;
  description: string;
}

@Component({
  selector: 'rvshare-windows-modal',
  templateUrl: './rvshare-windows-modal.component.html',
  styleUrl: './rvshare-windows-modal.component.scss',
  standalone: false,
})
export class RvshareWindowsModalComponent implements OnDestroy {
  // TODO: replace with the desktop app's scheme once rv-share-electron registers one.
  static readonly LAUNCH_URL = 'rvshare://';
  // How long a launch may take to take the focus from the page before it counts as failed.
  static readonly LAUNCH_TIMEOUT_MS = 2500;
  // Names the dialog: the modal service points the dialog's aria-labelledby at it.
  static readonly TITLE_ID = 'rvshare-windows-modal-title';

  readonly titleId = RvshareWindowsModalComponent.TITLE_ID;

  // TODO: replace both with the Rise Vision Share for Windows pages before release.
  readonly downloadUrl = '#';
  readonly helpGuideUrl = '#';

  readonly features: readonly WindowsAppFeature[] = [
    {
      title: 'Remote Touchback Control',
      description:
        'Control your computer from any interactive display using touch, mouse, or keyboard.',
    },
    {
      title: '1-Click Tray Launch',
      description:
        'Starts with Windows and sits in your system tray. Jump straight into sharing with 1 click without opening a browser.',
    },
    {
      title: 'Background Auto-Updates & Quick Join',
      description:
        'Join via code or SSO. Keeps itself updated silently in the background.',
    },
  ];

  launchFailed = false;

  private launchTimeout: ReturnType<typeof setTimeout>;
  private onLaunchBlur: () => void;

  constructor(public dialogRef: MatDialogRef<RvshareWindowsModalComponent>) {}

  ngOnDestroy() {
    this.stopWaitingForLaunch();
  }

  dismiss() {
    this.dialogRef.close(false);
  }

  download() {
    window.open(this.downloadUrl, '_blank');
    this.dialogRef.close(true);
  }

  // A browser can't tell whether a custom scheme opened anything. Opening the app, or the browser asking to, takes
  // the focus from the page; nothing taking it means the app isn't installed. Losing it proves nothing either (the
  // person may just have switched tabs), so the modal stays open, download included, until they close it.
  launchApp() {
    this.stopWaitingForLaunch();
    this.launchFailed = false;

    let focusLost = false;
    this.onLaunchBlur = () => (focusLost = true);
    window.addEventListener('blur', this.onLaunchBlur);

    this.openLaunchUrl();

    this.launchTimeout = setTimeout(() => {
      this.stopWaitingForLaunch();
      this.launchFailed = !focusLost;
    }, RvshareWindowsModalComponent.LAUNCH_TIMEOUT_MS);
  }

  openLaunchUrl() {
    window.location.href = RvshareWindowsModalComponent.LAUNCH_URL;
  }

  private stopWaitingForLaunch() {
    clearTimeout(this.launchTimeout);
    if (this.onLaunchBlur) {
      window.removeEventListener('blur', this.onLaunchBlur);
      this.onLaunchBlur = null;
    }
  }
}
